import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { fadeUp, viewport } from "@/lib/motion";

const BeforeAfter = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], [40, -40]);
  const y2 = useTransform(scrollYProgress, [0, 1], [-30, 50]);

  return (
    <section ref={ref} className="py-24 md:py-32 relative overflow-hidden" data-testid="before-after">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="mb-14 max-w-3xl">
          <p className="text-[#ccff00] text-xs font-semibold uppercase tracking-widest mb-4">The 48-hour transformation</p>
          <h2 className="font-display font-black tracking-tighter text-4xl md:text-5xl lg:text-6xl leading-tight">
            From zero online presence to fully launched.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          <motion.div style={{ y: y1 }} className="relative rounded-2xl overflow-hidden border border-white/10 group" data-testid="before-card">
            <img
              src="https://images.unsplash.com/photo-1499750310107-5fef28a66643?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxtZXNzeSUyMGRlc2slMjBsYXB0b3B8ZW58MHx8fHwxNzg3ODU5OTQ5fDA&ixlib=rb-4.1.0&q=85"
              alt="Before — no online presence"
              className="w-full h-72 md:h-[26rem] object-cover grayscale opacity-70 group-hover:opacity-90 transition-opacity"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
            <div className="absolute top-5 left-5 rounded-full bg-black/70 border border-white/20 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-zinc-300">Before</div>
            <div className="absolute bottom-6 left-6 right-6">
              <p className="font-display font-bold text-xl mb-2">Day 0</p>
              <p className="text-zinc-300 text-sm">No website. No logo. No Google listing. Just a phone number scribbled on a van.</p>
            </div>
          </motion.div>

          <motion.div style={{ y: y2 }} className="relative rounded-2xl overflow-hidden volt-glow group" data-testid="after-card">
            <img
              src="https://images.unsplash.com/photo-1565065598196-aa15dde2cbca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxjbGVhbiUyMG1vZGVybiUyMG5lb24lMjB3b3Jrc3BhY2V8ZW58MHx8fHwxNzg3ODU5OTQ5fDA&ixlib=rb-4.1.0&q=85"
              alt="After — fully launched business"
              className="w-full h-72 md:h-[26rem] object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
            <div className="absolute top-5 left-5 rounded-full bg-[#ccff00] px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-black">After · 48h</div>
            <div className="absolute bottom-6 left-6 right-6">
              <p className="font-display font-bold text-xl mb-2 text-[#ccff00]">Live by Friday</p>
              <p className="text-zinc-200 text-sm">Brand, website, Google Business, email and socials — all live, all professional.</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfter;
